import Marquee from "react-fast-marquee";
import { TRUST } from "@/data/site";

export const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="bg-sage py-12 overflow-hidden select-none">
      <Marquee speed={38} gradient={false} pauseOnHover>
        {[...TRUST, ...TRUST].map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif italic text-2xl sm:text-3xl text-sand px-8">{t}</span>
            <span className="text-sand/50 text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
